import _ from 'lodash';
import { notification } from 'antd';

const error = (type, data = {}, opts = {}) => {
  if (!_.isEmpty(data)) {
    const notificationData = _.isString(data) ? { message: data } : data;
    notification.error(notificationData);
  }

  return ({ type, data, ...opts });
};

export default error;
